import styled from "styled-components";

const StyledContainer = styled.div`
  position: relative;

  h5 {
    max-width: 200px;
  }

  .label-place {
    border-radius: 4px;
    border-bottom: 2px solid rgba(0, 0, 0, 0.4);
    background: rgba(255, 255, 255, 0.8);
    box-shadow: 0 6px 8px 0 rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(2px);

    align-items: center;
    border-bottom: 2px solid rgba(0, 0, 0, 0.1);
    color: ${({ token }) => token.colorPrimary};
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    width: 58px;
    height: 43px;
    right: -10px;
    top: -10px;

    h5 {
      font-size: 16px;
      font-weight: 800;
      margin: unset;
    }

    p {
      font-size: 12px;
      margin: unset;
    }
  }
`;

export default StyledContainer;
